// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.full-width {
  width: 100%;
}
.full-height {
  height: 100%;
}
.flex-h {
  display: flex;
  flex-direction: row;
}
.flex-v {
  display: flex;
  flex-direction: column;
}
.flex-grow {
  flex-grow: 1;
}
.nowrap {
  white-space: nowrap;
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
h1 {
  font-size: 36px;
}
h3,
h1 {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  margin-top: 20px;
  margin-bottom: 10px;
}
button,
input,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
.row {
  margin-right: -15px;
  margin-left: -15px;
}
.pull-left {
  float: left !important;
}
.pull-right {
  float: right !important;
}
.fade {
  opacity: 0;
  -webkit-transition: opacity 0.15s linear;
  -o-transition: opacity 0.15s linear;
  transition: opacity 0.15s linear;
}
.fade.in {
  opacity: 1;
}
a {
  color: #8784ee;
  text-decoration: none;
}
.form-themed table {
  color: var(--text-primary-color);
}
.form-themed table th,
.form-themed table td {
  font-size: 15px;
  font-weight: normal;
}
.form-themed table th {
  line-height: 60px;
}
.form-themed table td {
  line-height: 18px;
  padding: 0;
}
.form-themed .p-r-1 {
  padding-right: 1rem !important;
}
.form-themed label {
  margin-bottom: 5px;
}
.form-themed label.wrapperLabel {
  cursor: pointer;
}
.form-themed label.wrapperLabel:not(.checkboxLabel) {
  cursor: pointer;
  display: flex;
  flex-direction: column;
}
.form-themed label.wrapperLabel:not(.checkboxLabel) .wrapperText {
  display: block;
  order: -1;
}
.form-themed .btn[disabled],
.form-themed input[type=text][disabled],
.form-themed input[type=password][disabled],
.form-themed input[type=number][disabled],
.form-themed .btn.disabled,
.form-themed input[type=text].disabled,
.form-themed input[type=password].disabled,
.form-themed input[type=number].disabled,
.form-themed .btn[disabled]:hover,
.form-themed input[type=text][disabled]:hover,
.form-themed input[type=password][disabled]:hover,
.form-themed input[type=number][disabled]:hover,
.form-themed .btn.disabled:hover,
.form-themed input[type=text].disabled:hover,
.form-themed input[type=password].disabled:hover,
.form-themed input[type=number].disabled:hover,
.form-themed .btn[disabled]:active,
.form-themed input[type=text][disabled]:active,
.form-themed input[type=password][disabled]:active,
.form-themed input[type=number][disabled]:active,
.form-themed .btn.disabled:active,
.form-themed input[type=text].disabled:active,
.form-themed input[type=password].disabled:active,
.form-themed input[type=number].disabled:active {
  background-color: var(--ui-gray-darker);
  border-color: var(--ui-gray-light);
  color: var(--text-primary-color);
}
.form-themed .btn[disabled] + .wrapperText,
.form-themed input[type=text][disabled] + .wrapperText,
.form-themed input[type=password][disabled] + .wrapperText,
.form-themed input[type=number][disabled] + .wrapperText,
.form-themed .btn.disabled + .wrapperText,
.form-themed input[type=text].disabled + .wrapperText,
.form-themed input[type=password].disabled + .wrapperText,
.form-themed input[type=number].disabled + .wrapperText,
.form-themed .btn[disabled]:hover + .wrapperText,
.form-themed input[type=text][disabled]:hover + .wrapperText,
.form-themed input[type=password][disabled]:hover + .wrapperText,
.form-themed input[type=number][disabled]:hover + .wrapperText,
.form-themed .btn.disabled:hover + .wrapperText,
.form-themed input[type=text].disabled:hover + .wrapperText,
.form-themed input[type=password].disabled:hover + .wrapperText,
.form-themed input[type=number].disabled:hover + .wrapperText,
.form-themed .btn[disabled]:active + .wrapperText,
.form-themed input[type=text][disabled]:active + .wrapperText,
.form-themed input[type=password][disabled]:active + .wrapperText,
.form-themed input[type=number][disabled]:active + .wrapperText,
.form-themed .btn.disabled:active + .wrapperText,
.form-themed input[type=text].disabled:active + .wrapperText,
.form-themed input[type=password].disabled:active + .wrapperText,
.form-themed input[type=number].disabled:active + .wrapperText {
  color: var(--text-primary-color);
  cursor: auto;
}
.form-themed input[type=text],
.form-themed input[type=password],
.form-themed input[type=number] {
  background-color: var(--ui-gray);
  border-color: var(--ui-border-color);
  color: var(--text-primary-color);
  font-weight: normal;
}
.form-themed input[type=text]:active,
.form-themed input[type=password]:active,
.form-themed input[type=number]:active,
.form-themed input[type=text]:focus,
.form-themed input[type=password]:focus,
.form-themed input[type=number]:focus {
  background-color: var(--ui-gray-dark);
  border: 2px solid var(--active-color);
  box-shadow: none;
}
.form-themed input[type=text]:active + .wrapperText,
.form-themed input[type=password]:active + .wrapperText,
.form-themed input[type=number]:active + .wrapperText,
.form-themed input[type=text]:focus + .wrapperText,
.form-themed input[type=password]:focus + .wrapperText,
.form-themed input[type=number]:focus + .wrapperText {
  color: var(--active-color);
}
.form-themed .btn-primary {
  background-color: var(--active-color);
  border-collapse: var(--ui-border-color-active);
  color: var(--ui-text-color-active);
}
.form-themed .btn-primary:hover,
.form-themed .btn-primary:active,
.form-themed .btn-primary:focus,
.form-themed .btn-primary:focus:active {
  background-color: var(--ui-active-color);
  border-collapse: var(--ui-border-color-active);
  color: var(--ui-text-color-active);
}
.form-themed .form-control {
  background-color: #fff;
  border: 0;
  font-size: 14px;
  height: 30px;
  line-height: 16px;
  padding: 8px 9px 6px;
}
.form-control {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
}
.form-control:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,0.075), 0 0 8px rgba(102,175,233,0.6);
  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075), 0 0 8px rgba(102,175,233,0.6);
}
.form-control::-ms-expand {
  border: 0;
  background-color: transparent;
}
.form-control[disabled],
.form-control[readonly],
fieldset[disabled] .form-control {
  background-color: ;
  opacity: 1;
}
.form-control[disabled],
fieldset[disabled] .form-control {
  cursor: ;
}
input[type=range] {
  display: block;
  width: 100%;
}
.btn-danger {
  color: #fff;
  background-color: #d9534f;
  border-color: #d43f3a;
}
.btn-primary {
  color: #fff;
  background-color: #8784ee;
  border-color: #4a5582;
}
.btn-default {
  color: #333;
  background-color: #fff;
  border-color: #ccc;
}
.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}
.btn.disabled,
.btn[disabled],
fieldset[disabled] .btn {
  cursor: not-allowed;
  -webkit-box-shadow: none;
  box-shadow: none;
  opacity: 0.65;
}
button.close {
  -webkit-appearance: none;
  padding: 0;
  cursor: pointer;
  background: 0 0;
  border: 0;
}
.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}
.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
.ViewportDownloadForm {
  display: flex;
  flex-direction: column;
  z-index: 1080 !important;
}
.ViewportDownloadForm input,
.ViewportDownloadForm select {
  max-height: 30px;
}
.ViewportDownloadForm #keep-aspect svg {
  margin-top: 3px;
}
.ViewportDownloadForm .title {
  margin: 0;
  font-weight: bold;
}
.ViewportDownloadForm .file-info-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 20px 0;
  border-radius: 5px;
  padding: 20px 10px;
  background-color: var(--ui-gray-dark);
}
@media screen and (max-width: 1023px) {
  .ViewportDownloadForm .file-info-container {
    flex-direction: column;
    align-items: flex-start;
  }
}
.ViewportDownloadForm .file-info-container .width,
.ViewportDownloadForm .file-info-container .height,
.ViewportDownloadForm .file-info-container .file-name,
.ViewportDownloadForm .file-info-container .file-type {
  height: 56px;
}
.ViewportDownloadForm .file-info-container .input-ohif {
  margin: 0 5px;
}
.ViewportDownloadForm .file-info-container .file-name .select-ohif,
.ViewportDownloadForm .file-info-container .file-type .select-ohif,
.ViewportDownloadForm .file-info-container .file-name .input-ohif,
.ViewportDownloadForm .file-info-container .file-type .input-ohif {
  width: 170px;
}
.ViewportDownloadForm .file-info-container .file-name .input-ohif-label,
.ViewportDownloadForm .file-info-container .file-type .input-ohif-label,
.ViewportDownloadForm .file-info-container .file-name .select-ohif-label,
.ViewportDownloadForm .file-info-container .file-type .select-ohif-label {
  width: 90px;
  display: inline-block;
}
@media screen and (max-width: 1023px) {
  .ViewportDownloadForm .file-info-container .file-name .input-ohif-label,
  .ViewportDownloadForm .file-info-container .file-type .input-ohif-label,
  .ViewportDownloadForm .file-info-container .file-name .select-ohif-label,
  .ViewportDownloadForm .file-info-container .file-type .select-ohif-label {
    width: 120px;
  }
}
.ViewportDownloadForm .file-info-container .dimension-wrapper {
  display: flex;
  flex-direction: row;
}
.ViewportDownloadForm .file-info-container .dimension-wrapper .dimensions {
  display: flex;
  flex-direction: column;
}
.ViewportDownloadForm .file-info-container .dimension-wrapper .dimensions .input-ohif-label {
  width: 120px;
  display: inline-block;
}
@media screen and (max-width: 1023px) {
  .ViewportDownloadForm .file-info-container .dimension-wrapper .dimensions .input-ohif {
    width: 170px;
  }
}
.ViewportDownloadForm .file-info-container .dimension-wrapper .keep-aspect-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  height: 86px;
}
.ViewportDownloadForm .file-info-container .show-annotations {
  font-weight: bold;
  line-height: 30px;
}
.ViewportDownloadForm .file-info-container .show-annotations input {
  margin-right: 7px;
  vertical-align: middle;
}
.ViewportDownloadForm .file-info-container .show-annotations label {
  display: flex;
  justify-content: center;
  align-items: center;
}
.ViewportDownloadForm .loading-image {
  height: 580px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--active-color);
  font-size: 20px;
}
.ViewportDownloadForm .loading-image .icon-spin {
  margin-right: 15px;
}
.ViewportDownloadForm .preview {
  display: flex;
  flex-direction: column;
  background-color: var(--ui-gray-dark);
  padding: 10px;
  border-radius: 5px;
  justify-content: flex-start;
  align-items: center;
  height: 580px;
}
.ViewportDownloadForm .preview .viewport-preview {
  max-height: 512px;
  max-width: 512px;
}
.ViewportDownloadForm .preview .preview-header {
  width: 100%;
  text-align: center;
  font-size: 1.3em;
  margin: 0 0 10px;
}
.ViewportDownloadForm .actions {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
}
.ViewportDownloadForm .actions .btn {
  margin: 0 10px;
}
.ViewportDownloadForm .input-error {
  font-size: 12px;
  color: #f00;
  text-align: center;
  margin: 3px 0;
}
.modal-dialog {
  height: 100%;
}
.modal-dialog .modal-body {
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/common/global.styl","webpack://./../../ui/src/components/content/viewportDownloadForm/ViewportDownloadForm.styl","webpack://./../../ui/src/components/common/form.styl","webpack://./../../ui/src/components/common/button.styl"],"names":[],"mappings":"AAAA;EACE,8BAAoB;EACpB,2BAAiB;EACjB,sBAAY;ACCd;ADCA;EACE,WAAO;ACCT;ADCA;EACE,YAAQ;ACCV;ADCA;EACE,aAAS;EACT,mBAAgB;ACClB;ADCA;EACE,aAAS;EACT,sBAAgB;ACClB;ADCA;EACE,YAAW;ACCb;ADCA;EACE,mBAAa;ACCf;ADCA;EACE,iBAAY;ACCd;ADCA;EACE,kBAAY;ACCd;ADCA;EACE,gBAAY;ACCd;ADCA;EACE,eAAW;ACCb;ADCA;;EACE,oBAAa;EACb,gBAAa;EACb,gBAAa;EACb,gBAAY;EACZ,mBAAe;ACEjB;ADAA;;;;EACE,oBAAa;EACb,kBAAW;EACX,oBAAa;ACKf;ADHA;EACE,mBAAc;EACd,kBAAa;ACKf;ADHA;EACE,sBAAO;ACKT;ADHA;EACE,uBAAO;ACKT;ADHA;EACE,UAAS;EACT,wCAAoB;EACpB,mCAAe;EACf,gCAAY;ACKd;ADHA;EACE,UAAS;ACKX;ADHA;EACE,cAAO;EACP,qBAAiB;ACKnB;ACzEE;EACE,gCAAO;AD2EX;ACzEI;;EACE,eAAW;EACX,mBAAa;AD4EnB;AC1EI;EACE,iBAAa;AD4EnB;AC1EI;EACE,iBAAa;EACb,UAAS;AD4Ef;ACzEE;EACE,8BAAe;AD2EnB;ACzEE;EACE,kBAAe;AD2EnB;ACxEE;EACE,eAAQ;AD0EZ;ACxEE;EACE,eAAQ;EACR,aAAS;EACT,sBAAgB;AD0EpB;ACxEI;EACE,cAAS;EACT,SAAO;AD0Eb;ACrEM;;;;;;;;;;;;;;;;;;;;;;;;EACE,uCAAkB;EAClB,kCAAc;EACd,gCAAO;AD8Ff;AC5FQ;;;;;;;;;;;;;;;;;;;;;;;;EACE,gCAAO;EACP,YAAQ;ADqHlB;ACnHE;;;EACE,gCAAkB;EAClB,oCAAc;EACd,gCAAO;EACP,mBAAa;ADuHjB;ACpHI;;;;;;EACE,qCAAkB;EAClB,qCAAQ;EACR,gBAAY;AD2HlB;ACzHM;;;;;;EACE,0BAAO;ADgIf;AC9HE;EACE,qCAAkB;EAClB,8CAAiB;EACjB,kCAAO;ADgIX;AC7HI;;;;EAEE,wCAAkB;EAClB,8CAAiB;EACjB,kCAAO;ADiIb;AC/HE;EACE,sBAAkB;EAClB,SAAQ;EAER,eAAW;EACX,YAAQ;EACR,iBAAa;EACb,oBAAS;ADgIb;AC9HA;EACE,cAAS;EACT,WAAO;EACP,YAAQ;EACR,iBAAS;EACT,eAAW;EACX,uBAAa;EACb,WAAO;EACP,sBAAkB;EAClB,sBAAkB;EAClB,sBAAQ;EACR,kBAAe;EACf,6CAAY;ADgId;AC9HE;EACE,qBAAc;EACd,UAAS;EACT,oFAAoD;EACpD,4EAA4C;ADgIhD;AC9HE;EACE,SAAQ;EACR,6BAAkB;ADgItB;AC9HE;;;EAGE,kBAAkB;EAClB,UAAS;ADgIb;AC9HE;;EAEE,QAAQ;ADgIZ;AC9HA;EACE,cAAS;EACT,WAAO;ADgIT;AExPA;EACE,WAAO;EACP,yBAAkB;EAClB,qBAAc;AF0PhB;AExPA;EACE,WAAO;EACP,yBAAkB;EAClB,qBAAc;AF0PhB;AExPA;EACE,WAAO;EACP,sBAAkB;EAClB,kBAAc;AF0PhB;AExPA;EACE,qBAAS;EACT,iBAAS;EACT,gBAAe;EACf,eAAW;EACX,gBAAa;EACb,uBAAa;EACb,kBAAY;EACZ,mBAAa;EACb,sBAAgB;EAChB,8BAAkB;EAClB,0BAAc;EACd,eAAQ;EACR,yBAAqB;EACrB,sBAAkB;EAClB,qBAAiB;EACjB,iBAAa;EACb,sBAAkB;EAClB,6BAAQ;EACR,kBAAe;AF0PjB;AExPA;;;EACE,mBAAQ;EACR,wBAAoB;EACpB,gBAAY;EACZ,aAAS;AF4PX;AE1PA;EACE,wBAAoB;EACpB,UAAS;EACT,eAAQ;EACR,eAAY;EACZ,SAAQ;AF4PV;AE1PA;;EACE,kBAAU;EACV,qBAAS;EACT,sBAAgB;AF6PlB;AE3PA;EACE,uBAAS;EACT,mBAAW;EACX,gBAAa;EACb,qBAAe;AF6PjB;AAnTA;EACE,aAAS;EACT,sBAAgB;EAChB,wBAAS;AAqTX;AAnTE;;EACE,gBAAY;AAsThB;AApTE;EACE,eAAY;AAsThB;AApTE;EACE,SAAQ;EACR,iBAAa;AAsTjB;AApTE;EACE,aAAS;EACT,mBAAgB;EAChB,6BAAiB;EACjB,cAAQ;EACR,kBAAe;EACf,kBAAS;EACT,qCAAkB;AAsTtB;AApTwC;EAAA;IAClC,sBAAgB;IAChB,uBAAa;EAuTjB;AACF;AAtTI;;;;EAIE,YAAQ;AAwTd;AAtTI;EACE,aAAQ;AAwTd;AApTM;;;;EACE,YAAO;AAyTf;AAvTM;;;;EACE,WAAO;EACP,qBAAS;AA4TjB;AA3T4C;EAAA;;;;IAClC,YAAO;EAiUf;AACF;AAhUI;EACE,aAAS;EACT,mBAAgB;AAkUtB;AAhUM;EACE,aAAS;EACT,sBAAgB;AAkUxB;AAhUQ;EACE,YAAO;EACP,qBAAS;AAkUnB;AA/T8C;EAAA;IAClC,YAAO;EAkUjB;AACF;AAjUM;EACE,aAAS;EACT,uBAAiB;EACjB,mBAAa;EACb,eAAS;EACT,YAAQ;AAmUhB;AAjUI;EACE,iBAAa;EACb,iBAAa;AAmUnB;AAlUM;EACE,iBAAc;EACd,sBAAgB;AAoUxB;AAnUM;EACE,aAAS;EACT,uBAAiB;EACjB,mBAAa;AAqUrB;AAnUE;EACE,aAAQ;EACR,aAAS;EACT,uBAAiB;EACjB,mBAAa;EACb,0BAAO;EACP,eAAW;AAqUf;AAnUI;EACE,kBAAc;AAqUpB;AAnUE;EACE,aAAS;EACT,sBAAgB;EAChB,qCAAkB;EAClB,aAAS;EACT,kBAAe;EACf,2BAAiB;EACjB,mBAAa;EACb,aAAQ;AAqUZ;AAnUI;EACE,iBAAY;EACZ,gBAAW;AAqUjB;AAnUI;EACE,WAAO;EACP,kBAAW;EACX,gBAAW;EACX,gBAAQ;AAqUd;AAnUE;EACE,aAAS;EACT,iBAAW;EACX,yBAAiB;EACjB,mBAAa;EACb,gBAAY;AAqUhB;AAnUI;EACE,cAAQ;AAqUd;AAnUE;EACE,eAAW;EACX,WAAO;EACP,kBAAY;EACZ,aAAQ;AAqUZ;AAlUA;EACE,YAAQ;AAoUV;AAlUE;EACE,aAAS;EACT,sBAAgB;AAoUpB","sourcesContent":["*\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n\n.full-width\n  width: 100%\n\n.full-height\n  height: 100%\n\n.flex-h\n  display: flex\n  flex-direction: row\n\n.flex-v\n  display: flex\n  flex-direction: column\n\n.flex-grow\n  flex-grow: 1\n\n.nowrap\n  white-space: nowrap\n\n.text-right\n  text-align: right;\n\n.text-center\n  text-align: center;\n\n.text-left\n  text-align: left;\n\nh1\n  font-size: 36px;\n\nh3, h1\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 20px;\n  margin-bottom: 10px;\n\nbutton, input, select, textarea\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n\n.row\n  margin-right: -15px;\n  margin-left: -15px;\n\n.pull-left\n  float: left!important;\n\n.pull-right\n  float: right!important;\n\n.fade\n  opacity: 0;\n  -webkit-transition: opacity .15s linear;\n  -o-transition: opacity .15s linear;\n  transition: opacity .15s linear;\n\n.fade.in\n  opacity: 1;\n\na\n  color: #8784EE;\n  text-decoration: none;\n","@import '../../common/global.styl'\n@import '../../common/form.styl'\n@import '../../common/button.styl'\n\n.ViewportDownloadForm\n  display: flex;\n  flex-direction: column;\n  z-index: 1080 !important;\n\n  input, select\n    max-height: 30px;\n\n  #keep-aspect svg\n    margin-top: 3px;\n\n  .title\n    margin: 0;\n    font-weight: bold;\n\n  .file-info-container\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    margin: 20px 0;\n    border-radius: 5px;\n    padding: 20px 10px;\n    background-color: var(--ui-gray-dark);\n\n    @media screen and (max-width: 1023px)\n      flex-direction: column;\n      align-items: flex-start;\n\n    .width,\n    .height,\n    .file-name,\n    .file-type\n      height: 56px;\n\n    .input-ohif\n      margin: 0 5px;\n\n    .file-name,\n    .file-type\n      .select-ohif, .input-ohif\n        width: 170px;\n\n      .input-ohif-label, .select-ohif-label\n        width: 90px;\n        display: inline-block;\n        @media screen and (max-width: 1023px)\n          width: 120px;\n\n    .dimension-wrapper\n      display: flex;\n      flex-direction: row;\n\n      .dimensions\n        display: flex;\n        flex-direction: column;\n\n        .input-ohif-label\n          width: 120px;\n          display: inline-block;\n\n        .input-ohif\n          @media screen and (max-width: 1023px)\n            width: 170px;\n\n      .keep-aspect-wrapper\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding: 0 10px;\n        height: 86px;\n\n    .show-annotations\n      font-weight: bold;\n      line-height: 30px;\n      input\n        margin-right: 7px;\n        vertical-align: middle;\n      label\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n  .loading-image\n    height: 580px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: var(--active-color);\n    font-size: 20px;\n\n    .icon-spin\n      margin-right: 15px;\n\n  .preview\n    display: flex;\n    flex-direction: column;\n    background-color: var(--ui-gray-dark);\n    padding: 10px;\n    border-radius: 5px;\n    justify-content: flex-start;\n    align-items: center;\n    height: 580px;\n\n    .viewport-preview\n      max-height: 512px;\n      max-width: 512px;\n\n    .preview-header\n      width: 100%;\n      text-align center;\n      font-size: 1.3em;\n      margin: 0 0 10px;\n\n  .actions\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: flex-end;\n    align-items: center;\n    margin-top: 20px;\n\n    .btn\n      margin: 0 10px;\n\n  .input-error\n    font-size: 12px;\n    color: red;\n    text-align: center;\n    margin: 3px 0;\n\n\n.modal-dialog\n  height: 100%;\n\n  .modal-body\n    display: flex;\n    flex-direction: column;\n",".form-themed\n\n  table\n    color: var(--text-primary-color)\n\n    th, td\n      font-size: 15px\n      font-weight: normal\n\n    th\n      line-height: 60px\n\n    td\n      line-height: 18px\n      padding: 0;\n\n  // TODO: imported this from merged-styles.css\n  .p-r-1\n    padding-right: 1rem !important;\n\n  label\n    margin-bottom: 5px\n  // end TODO\n\n  label.wrapperLabel\n    cursor: pointer\n\n  label.wrapperLabel:not(.checkboxLabel)\n    cursor: pointer\n    display: flex\n    flex-direction: column\n\n    .wrapperText\n      display: block\n      order: -1\n      transition(color 0.3s ease)\n\n  .btn, input[type=text], input[type=password], input[type=number]\n    &[disabled], &.disabled\n      &, &:hover, &:active\n        background-color: var(--ui-gray-darker)\n        border-color: var(--ui-gray-light)\n        color: var(--text-primary-color)\n\n        & + .wrapperText\n          color: var(--text-primary-color)\n          cursor: auto\n\n  input[type=text], input[type=password], input[type=number]\n    background-color: var(--ui-gray)\n    border-color: var(--ui-border-color)\n    color: var(--text-primary-color)\n    font-weight: normal\n    transition(background-color 0.3s ease\\, border-color 0.3s ease)\n\n    &:active, &:focus\n      background-color: var(--ui-gray-dark)\n      border: 2px solid var(--active-color)\n      box-shadow: none\n\n      & + .wrapperText\n        color: var(--active-color)\n\n  .btn-primary\n    background-color: var(--active-color)\n    border-collapse: var(--ui-border-color-active)\n    color: var(--ui-text-color-active)\n    transition(background-color 0.3s ease\\, border-color 0.3s ease)\n\n    &:hover, &:active, &:focus, &:focus:active\n      // TODO: 0.8  opacity\n      background-color: var(--ui-active-color)\n      border-collapse: var(--ui-border-color-active)\n      color: var(--ui-text-color-active)\n\n  .form-control\n    background-color: #FFFFFF\n    border: 0\n    border-radius(2px)\n    font-size: 14px\n    height: 30px\n    line-height: 16px\n    padding: 8px 9px 6px\n\n.form-control\n  display: block;\n  width: 100%;\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.075);\n\n  &:focus\n    border-color: #66afe9;\n    outline: 0;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);\n    box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);\n\n  &::-ms-expand\n    border: 0;\n    background-color: transparent;\n\n  &[disabled],\n  &[readonly],\n  fieldset[disabled] &\n    background-color: @input-bg-disabled;\n    opacity: 1;\n\n  &[disabled],\n  fieldset[disabled] &\n    cursor: @cursor-disabled;\n\ninput[type=range]\n  display: block;\n  width: 100%;\n",".btn-danger\n  color: #fff;\n  background-color: #d9534f;\n  border-color: #d43f3a;\n\n.btn-primary\n  color: #fff;\n  background-color: #8784EE;\n  border-color: #4A5582;\n\n.btn-default\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc;\n\n.btn\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n\n.btn.disabled, .btn[disabled], fieldset[disabled] .btn\n  cursor: not-allowed;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  opacity: .65;\n\nbutton.close\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: 0 0;\n  border: 0;\n\n.btn-group, .btn-group-vertical\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n\n.btn-sm\n  padding: .25rem .5rem;\n  font-size: .875rem;\n  line-height: 1.5;\n  border-radius: .2rem;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
